module.exports = __webpack_public_path__ + "static/media/fastapi.77eee8a5.jpg";